<script setup>
import {onMounted, ref, onBeforeUnmount} from "vue";

const mapContainer = ref(null)
const mapHeight = ref('556px') // 기본 높이

onMounted(() => {
  // 최초 로드 시 높이 설정
  updateMapHeight();

  // 창 크기가 변경될 때마다 높이를 재설정
  window.addEventListener('resize', updateMapHeight);

  // 카카오 지도 로드
  loadKakaoMap(mapContainer.value)
})

onBeforeUnmount(() => {
  // 컴포넌트가 파괴될 때 resize 이벤트 제거
  window.removeEventListener('resize', updateMapHeight);
})

const updateMapHeight = () => {
  if (window.innerWidth <= 768) {
    mapHeight.value = '300px'; // 모바일일 경우 낮은 높이 적용
  } else {
    mapHeight.value = '556px'; // 기본 높이
  }
}

const loadKakaoMap = (container) => {
  const script = document.createElement('script')
  script.src = 'https://dapi.kakao.com/v2/maps/sdk.js?appkey=05e62160f624f8211d8485041ab03015&autoload=false&libraries=services,clusterer,drawing'
  document.head.appendChild(script)

  script.onload = () => {
    window.kakao.maps.load(() => {
      const options = {
        center: new window.kakao.maps.LatLng(33.450701, 126.570667),
        level: window.innerWidth <= 768 ? 6 : 5,
      }

      const mapInstance = new window.kakao.maps.Map(container, options)
      var zoomControl = new window.kakao.maps.ZoomControl();
      mapInstance.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT);
      mapInstance.setZoomable(false);

      var geocoder = new window.kakao.maps.services.Geocoder();

      geocoder.addressSearch('서울특별시 강동구 천중로27길 51', function(result, status) {
        if (status === window.kakao.maps.services.Status.OK) {
          var coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);

          var marker = new window.kakao.maps.Marker({
            map: mapInstance,
            position: coords
          });

          var infowindow = new window.kakao.maps.InfoWindow({
            content: '<div style="width:150px;text-align:center;padding:6px 0;">천호제일감리교회</div>'
          });
          infowindow.open(mapInstance, marker);

          mapInstance.setCenter(coords);
        }
      });
    })
  }
}
</script>

<template>
  <!-- 동적으로 설정된 height 값을 사용 -->
  <div :style="{ height: mapHeight }" ref="mapContainer" id="map" style="width:100%;"></div>
</template>

<style scoped lang="scss">

</style>
